export type Scene = {
  id: string;
  label: string;
  title: string;
  content: string[];
  nested?: boolean;
  expanded?: boolean;
};

export const scenes: Scene[] = [
  {
    id: "prologue",
    label: "序章　雨夜",
    title: "序章 · 雨夜",
    content: ["雨把雾港的石阶冲得发亮。林默站在渡口，直到最后一班船熄灭舷灯。"],
  },
  {
    id: "chapter-1",
    label: "第一章　失踪的灯塔",
    title: "第一章 · 失踪的灯塔",
    content: ["灯塔停用后的第七天，港务局仍没有给出解释。"],
    expanded: true,
  },
  {
    id: "scene-1",
    label: "场景 01　抵达",
    title: "场景 01 · 抵达",
    content: ["渡船靠岸时，雾恰好遮住了灯塔顶端。"],
    nested: true,
  },
  {
    id: "scene-2",
    label: "场景 02　旧信",
    title: "场景 02 · 旧信",
    nested: true,
    content: [
      "雨停了，雾从海面爬上来，像一层迟疑的纱。林默在旧书摊的角落里翻到那封信，信封已经发黄，边角被潮气磨软。",
      "收信人写着父亲的名字。没有寄件人。只有一行地址：雾港灯塔管理处，落款处被墨水晕开，像被谁匆匆按住又松开。",
      "她犹豫了一下，拆开信封。纸张很薄，字迹是父亲的。最后一句被划了一道横线，墨色比其他地方更重。",
      "“如果你看到这封信，说明我大概不会回来了。”",
      "林默把信折好，放进口袋。外面的钟声响起，码头的铁链轻轻晃动，像有人在远处走过。",
    ],
  },
  {
    id: "scene-3",
    label: "场景 03　码头重逢",
    title: "场景 03 · 码头重逢",
    content: ["许栀撑着一把旧伞，站在泊位尽头，像从十年前的照片里走出来。"],
    nested: true,
  },
];

export const proposedContent = [
  "雨停了，雾从海面爬上来，像一层迟疑的纱。林默在旧书摊的角落里翻到那封信，信封已经发黄，边角被潮气磨软。",
  "收信人写着父亲的名字。没有寄件人。只有一行地址：雾港灯塔管理处，落款处被墨水晕开，像被谁匆匆按住又松开。",
  "她犹豫了一下，拆开信封。纸张很薄，字迹是父亲的。最后一句被划了一道横线，墨色比其他地方更重。",
  "“如果你看到这封信，说明我已经离开雾港。别找我，灯塔会替我记得你。”",
  "林默把信折好，放进口袋。外面的钟声响起，码头的铁链轻轻晃动，像有人在远处走过。",
];

